// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_container__nrxdr {
    width: var(--sidebar-width, 250px);
    background-color: var(--sidebar-background, #f4f4f4);
    border-right: var(--sidebar-border-right, 1px solid #eee);
    padding: var(--sidebar-padding, 10px);
    height: calc(100dvh - var(--header-height, 60px) - 2 * var(--header-padding, 10px));
    box-sizing: border-box;
    overflow-y: auto;
    min-height: 0;
    position: relative;
    transition: width 0.2s;
}

.Sidebar_toggleButton__rI0tO {
    position: absolute;
    top: 12px;
    left: 8px;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: 2px solid #1976d2;
    background: #fff;
    cursor: pointer;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    transition: background 0.2s, border 0.2s;
    font-size: 2rem;
    font-weight: bold;
    color: #1976d2;
}
.Sidebar_toggleButton__rI0tO:hover {
    background: #e3f0fc;
    border-color: #1565c0;
    color: #1565c0;
}

.Sidebar_menu__xmSnR {
    list-style: none;
    padding: 0;
    margin: 0;
}

.Sidebar_menuItem__JIc3L {
    padding: 8px 12px;
    border-bottom: 1px solid #eee;
}

.Sidebar_menuItem__JIc3L:hover {
    background-color: var(--sidebar-menu-item-hover, #eee);
}
`, "",{"version":3,"sources":["webpack://./src/Frame/Sidebar/Sidebar.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,oDAAoD;IACpD,yDAAyD;IACzD,qCAAqC;IACrC,mFAAmF;IACnF,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,sDAAsD;AAC1D","sourcesContent":[".container {\r\n    width: var(--sidebar-width, 250px);\r\n    background-color: var(--sidebar-background, #f4f4f4);\r\n    border-right: var(--sidebar-border-right, 1px solid #eee);\r\n    padding: var(--sidebar-padding, 10px);\r\n    height: calc(100dvh - var(--header-height, 60px) - 2 * var(--header-padding, 10px));\r\n    box-sizing: border-box;\r\n    overflow-y: auto;\r\n    min-height: 0;\r\n    position: relative;\r\n    transition: width 0.2s;\r\n}\r\n\r\n.toggleButton {\r\n    position: absolute;\r\n    top: 12px;\r\n    left: 8px;\r\n    width: 44px;\r\n    height: 44px;\r\n    border-radius: 50%;\r\n    border: 2px solid #1976d2;\r\n    background: #fff;\r\n    cursor: pointer;\r\n    z-index: 10;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow: 0 2px 8px rgba(0,0,0,0.08);\r\n    transition: background 0.2s, border 0.2s;\r\n    font-size: 2rem;\r\n    font-weight: bold;\r\n    color: #1976d2;\r\n}\r\n.toggleButton:hover {\r\n    background: #e3f0fc;\r\n    border-color: #1565c0;\r\n    color: #1565c0;\r\n}\r\n\r\n.menu {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.menuItem {\r\n    padding: 8px 12px;\r\n    border-bottom: 1px solid #eee;\r\n}\r\n\r\n.menuItem:hover {\r\n    background-color: var(--sidebar-menu-item-hover, #eee);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Sidebar_container__nrxdr`,
	"toggleButton": `Sidebar_toggleButton__rI0tO`,
	"menu": `Sidebar_menu__xmSnR`,
	"menuItem": `Sidebar_menuItem__JIc3L`
};
export default ___CSS_LOADER_EXPORT___;
